import { createSelector } from 'reselect';
import { ApplicationRootState } from 'types';
import { initialState } from '../reducers/pieces';
import { DoorHandle } from 'lib/modelBuilder/pieces/DoorHandle';
import { DrawerHandle } from 'lib/modelBuilder/pieces/DrawerHandle';
import { Plate } from '../../../lib/modelBuilder/pieces/Plate';

/**
 * Direct selector to the app state domain
 */

export const selectPiecesDomain = (state: ApplicationRootState) => {
  if (state.configurator) {
    return state.configurator.pieces || initialState;
  }
  return initialState;
};

export const makeSelectIsPiecesLoading = () =>
  createSelector(selectPiecesDomain, (substate): boolean => substate.loading);

export const makeSelectIsPiecesReady = () =>
  createSelector(selectPiecesDomain, (substate): boolean => !!substate.data);

export const makeSelectPieces = () =>
  createSelector(selectPiecesDomain, substate => substate.data);

export const makeSelectPlates = () =>
  createSelector(selectPiecesDomain, (substate): Plate[] => {
    if (substate && substate.data)
      return Array.from(substate.data.plates.list.values());
    else throw new Error('Pieces should be loaded');
  });

export const makeSelectDoorHandles = () =>
  createSelector(selectPiecesDomain, (substate): DoorHandle[] => {
    if (substate && substate.data)
      return Array.from(substate.data.doorsHandles.list.values());
    else throw new Error('Pieces should be loaded');
  });

export const makeSelectDrawersHandles = () =>
  createSelector(selectPiecesDomain, (substate): DrawerHandle[] => {
    if (substate && substate.data)
      return Array.from(substate.data.drawersHandles.list.values());
    else throw new Error('Pieces should be loaded');
  });
